<div class="p-2 min-h-screen">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-2">
    <h3 class="font-bold">{{ '::Orders' | abpLocalization }}</h3>
  </div>

  <!-- filtro -->
  <div class="w-full md:w-1/3 px-1 flex gap-1 flex-wrap justify-center overflow-visible">
    <app-metro-form-select [size]="'sm'" [placeholder]='"::Status" | abpLocalization' [options]="orderStatusOptions"
      [(ngModel)]="selectedStatus" (selectionChange)="onStatusChange($event)" [allowSearch]="false"
      selectedBackgroundClass="bg-metro-secondary" class="flex-1"></app-metro-form-select>
  </div>

  <!-- listado de órdenes -->
  <div class="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

    <app-metro-order-card-item *ngFor="let order of orders" [dateOrder]="order.creationTime" [status]="order.status"
      [itemCount]="order.itemCount" [totalPrice]="order.totalPrice" [orderNumber]="order.orderNumber" [id]="order.id"
      [navigationPath]="'order'">
    </app-metro-order-card-item>
  </div>
</div>